import { Empty } from 'assets/Illustrations'
import { number, string } from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components'

const StyledNoData = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 200px;
	justify-content: center;
	width: 100%;
	padding: 0 12px;
	& .icon {
		padding: 0 0 20px;
		max-width: 160px;
		width: 100%;
		& svg {
			height: auto;
			max-width: 100%;
		}
	}
	& p {
		color: #949494;
		font-size: 17px;
		font-weight: 500;
		text-align: center;
	}
	.dark & p {
		color: #e1e1e1;
	}
	@media (max-width: 480px) {
		height: 160px;
		& .icon {
			max-width: 110px;
			padding: 0 0 12px;
		}
		& p {
			font-size: 14px;
		}
	}
`

const NoData = ({ emptyMessage = '', colSpan = 1 }) => {
	const memoizedEmptyMessage = useMemo(() => {
		const isString = typeof emptyMessage === 'string'
		const memoizedEmptyMessage =
			isString && emptyMessage ? emptyMessage : 'Ma’lumot topilmadi'
		return memoizedEmptyMessage
	}, [emptyMessage])
	return (
		<tr>
			<td colSpan={colSpan}>
				<StyledNoData>
					<div className='icon'>
						<Empty />
					</div>
					<p>{memoizedEmptyMessage}</p>
				</StyledNoData>
			</td>
		</tr>
	)
}
NoData.propTypes = { colSpan: number, emptyMessage: string }
export default NoData